const currency = (value: any) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(value ?? 0));

export const PFAppendixInputJson = [
  { field: "policyYear", header: "Policy Year" },
  { field: "insuredAge", header: "Insured Age" },
  { field: "plannedPremium", header: "Planned Premium", formatter: currency },
  { field: "loan", header: "Loan", formatter: currency },
  { field: "annualIncome", header: "Annual Income", formatter: currency },
  { field: "accumulatedValue", header: "Accumulated Value", formatter: currency },
  { field: "surrenderValue", header: "Surrender Value", formatter: currency },
  { field: "netDeathBenefit", header: "Net Death Benefit", formatter: currency },
];

export default PFAppendixInputJson;
